import PropTypes from 'prop-types';
import {
  UspClock1h,
  UspLockers,
  UspPinTracking,
  UspPoundShield,
  UspPriceTag,
  UspUniform,
  UspWeightKg,
  UspWorld,
} from '../icons/usp';

const USP_ICON_COMPONENTS = {
  poundShield: UspPoundShield,
  lockers: UspLockers,
  uniform: UspUniform,
  price: UspPriceTag,
  weight: UspWeightKg,
  pin: UspPinTracking,
  world: UspWorld,
  '1hr': UspClock1h,
};

export default function DpdOnlineUspIcon({ variant }) {
  const Cmp = USP_ICON_COMPONENTS[variant];
  if (!Cmp) {
    return null;
  }

  return <Cmp sx={{ fontSize: 24, color: 'primary.main' }} />;
}

DpdOnlineUspIcon.propTypes = {
  variant: PropTypes.oneOf([
    'poundShield',
    'lockers',
    'uniform',
    'price',
    'weight',
    'pin',
    'world',
    '1hr',
  ]).isRequired,
};
